import { render, staticRenderFns } from "./RenewLicensesSidebar.vue?vue&type=template&id=370e701a&scoped=true"
import script from "./RenewLicensesSidebar.vue?vue&type=script&lang=js"
export * from "./RenewLicensesSidebar.vue?vue&type=script&lang=js"
import style0 from "./RenewLicensesSidebar.vue?vue&type=style&index=0&id=370e701a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370e701a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('370e701a')) {
      api.createRecord('370e701a', component.options)
    } else {
      api.reload('370e701a', component.options)
    }
    module.hot.accept("./RenewLicensesSidebar.vue?vue&type=template&id=370e701a&scoped=true", function () {
      api.rerender('370e701a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/OrganisationDetails/Licenses/RenewLicensesSidebar.vue"
export default component.exports